import { createIcon } from './createIcon'

export const AnalyticsTrashIcon = createIcon({
  displayName: 'AnalyticsTrashIcon',
  viewBox: '4.6665 3.5 10.6667 12',
  path: [
    <path
      d="M6.6665 15.5C6.29984 15.5 5.98595 15.3694 5.72484 15.1083C5.46373 14.8472 5.33317 14.5333 5.33317 14.1667V5.5H4.6665V4.16667H7.99984V3.5H11.9998V4.16667H15.3332V5.5H14.6665V14.1667C14.6665 14.5333 14.5359 14.8472 14.2748 15.1083C14.0137 15.3694 13.6998 15.5 13.3332 15.5H6.6665ZM13.3332 5.5H6.6665V14.1667H13.3332V5.5ZM7.99984 12.8333H9.33317V6.83333H7.99984V12.8333ZM10.6665 12.8333H11.9998V6.83333H10.6665V12.8333Z"
      fill="currentColor"
    />,
  ],
})
